import { get } from 'lodash'

/**
 * TODO Use canvas to determine text width https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Drawing_text
 * Basically write the text to canvas, measure it, determine if it's wide enough for vertical
 *
 * Determine if the actions should be vertical or horizontal based on the
 * contents of the buttons and other factors
 *
 * Character limits per device:
 * Web - Arial 13px font - M width = 10.142
 * 1btn = 29 (ish)
 * 2btn = 12
 * 3btn = 7
 * 4btn = 4
 *
 * Mobile M width ~= 12
 * Mobile iPhone SE (320 with)
 * 1btn = ?
 * 2btn = 10
 * 3btn = 6
 * 4btn = 4
 *
 * Mobile iPhone X (375 width)
 * 1btn = ?
 * 2btn = 12
 * 3btn = ?
 * 4btn = ?
 *
 * @param theme
 * @param actions
 * @param mWidth
 * @returns {string}
 */
export function getActionOrientation(theme: any, actions: any[] = [], mWidth = 10.142) {
  if (actions.length <= 1) {
    return 'vertical'
  }
  // 1 M = 10.142 px (web at 13px font size, using Arial)
  const spacing = theme.spacing[theme.actions.spacing]
  const numberOfSpaces = actions.length + 1
  const widthOfCard = theme.summary.width - theme.summary.cardMargin * 2
  const paddingPerButton = getSpacingFromNumberOrName(theme, theme.actions.buttonSpacing) * 2

  // Determine pixel quantity per button reserved for text
  const totalTextArea = widthOfCard - numberOfSpaces * spacing - paddingPerButton * actions.length
  const maxCharactersPerButton = totalTextArea / actions.length / mWidth
  const shouldGoVertical = actions.some(action => action.title.length > maxCharactersPerButton)
  return shouldGoVertical ? 'vertical' : 'horizontal'
}

export function getSpacingFromNumberOrName(theme: any, spacing: any) {
  if (typeof spacing === 'string') {
    // Look up the number based on the "spacing" theme attribute
    return get(theme, `spacing[${spacing}]`, 0)
  }
  return spacing
}

export { getErrorCard } from './errorAdaptiveCard'
